export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 dot-pattern opacity-40 pointer-events-none"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-primary-500/5 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-1/3 w-[400px] h-[400px] rounded-full bg-accent-500/5 blur-3xl pointer-events-none"></div>

      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left animate-fade-in-up">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse-soft"></span>
              每日实时更新 · 一手爆料资讯
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-[3.4rem] leading-tight text-foreground-950 mb-4 tracking-tight">
              爆料网
              <span className="block text-2xl sm:text-3xl md:text-4xl font-medium text-foreground-700 mt-1">
                吃瓜群众的每日爆料新入口
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-4">
              爆料网为您聚合全网最新爆料资讯与独家内幕，覆盖51爆料网、91爆料网等热门来源，
              实时同步每日吃瓜爆料内容。无论9-11爆料网是否打不开，本站提供稳定入口，
              确保您不错过任何热点爆料与精彩话题。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8 text-sm text-foreground-500">
              <div className="flex items-center gap-2">
                <i className="ri-fire-line text-accent-500 text-lg"></i>
                <span>今日更新 <strong className="text-foreground-800 font-semibold">138</strong> 条爆料</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-group-line text-primary-500 text-lg"></i>
                <span>覆盖 <strong className="text-foreground-800 font-semibold">50+</strong> 爆料来源</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-500 text-lg"></i>
                <span>7×24小时 <strong className="text-foreground-800 font-semibold">不间断更新</strong></span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-base rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap text-center"
              >
                <i className="ri-arrow-down-line mr-2"></i>查看最新爆料
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-primary-200 text-primary-700 font-semibold text-base rounded-lg hover:bg-primary-50 transition-all whitespace-nowrap text-center"
              >
                <i className="ri-smartphone-line mr-2"></i>下载爆料网App
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none animate-slide-left">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-500/10 via-accent-500/5 to-transparent rounded-2xl blur-xl"></div>
              <div className="relative bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden p-2">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20artistic%20illustration%20of%20breaking%20news%20concept%20with%20warm%20red%20and%20amber%20gradients%2C%20abstract%20newspaper%20fragments%20floating%20in%20dynamic%20composition%2C%20magnifying%20glass%20and%20megaphone%20silhouettes%2C%20clean%20modern%20design%20with%20bold%20contrast%2C%20editorial%20style%2C%20professional%20newsroom%20atmosphere%2C%20stylized%20minimalist%20aesthetic%20with%20textured%20layers%20on%20warm%20cream%20background&width=1200&height=900&seq=hero-main-visual-2026&orientation=landscape"
                  alt="爆料网 - 每日爆料资讯聚合平台主视觉"
                  className="w-full h-auto rounded-xl"
                  width="1200"
                  height="900"
                />
              </div>
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl border border-background-200/70 px-4 py-3 flex items-center gap-3 animate-fade-in-up">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-600 text-xl"></i>
                </div>
                <div>
                  <div className="text-xs text-foreground-500">今日热点</div>
                  <div className="text-sm font-semibold text-foreground-900">娱乐圈最新大瓜持续更新中</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}